import { Controller } from "@hotwired/stimulus"

// Handles removal of a nested form row (soft delete for persisted, DOM removal for new).
// Set data-removable-row-event-name-value to customize the dispatched event.
export default class extends Controller {
  static targets = ["destroy"]
  static values = { eventName: { type: String, default: "row:removed" } }

  remove(event) {
    event.preventDefault()

    const parent = this.element.parentElement
    const idInput = this.element.querySelector("input[name*='[id]']")

    if (!idInput || !idInput.value) {
      this.element.remove()
    } else {
      if (this.hasDestroyTarget) {
        this.destroyTarget.value = "1"
      }
      this.disableFieldsForDestroyedRow(idInput)
      this.element.classList.add("hidden")
    }

    parent.dispatchEvent(new CustomEvent(this.eventNameValue, { bubbles: true }))
  }

  disableFieldsForDestroyedRow(idInput) {
    const fields = this.element.querySelectorAll("input, textarea, select")
    const destroyField = this.hasDestroyTarget ? this.destroyTarget : null

    fields.forEach((field) => {
      if (field === destroyField || field === idInput) return
      field.disabled = true
    })
  }
}
